/**
 * Defect, use case and ML model names are unique case-insensitively in the
 * database (`UniqueConstraint(Lower("name"))`), but the DRF `name` filter is an
 * `exact` match on a plain varchar column, so `?name=ABC` will not find `abc`.
 *
 * Availability checks therefore query `name__icontains`, which is
 * case-insensitive but also matches substrings, and narrow the result down to a
 * true case-insensitive equality here.
 */
export const isNameTaken = <T extends { name?: string | null }>(
  results: Array<T> | undefined | null,
  value: string
): boolean => {
  const target = value.trim().toLowerCase();

  if (!target) {
    return false;
  }

  return !!results?.some(item => item?.name?.trim().toLowerCase() === target);
};
